<template>
  <div id="order-filters-anchor-links">
    <p id="undefined-from-filters" :counterTextObserver="productObserver"></p>
    <Observer :options="getObserverOptions" />
    <div
      class="filters-wrap"
      v-if="
        isEdvPage || (productCounterString && !productCounterString.startsWith('undefined'))
      "
    >
      <div 
        id="order-filters-id"
        class="watch-sticky block"
        :class="[
          getBackgroundImage ? 'bg-image-rule' : ''
        ]"
        :style="[
          {'top': '55px'},
          getBackgroundImage
        ]" 
      >
        <div class="slide-panel">
          <div
            class="order-filters col-sm-12 flex-row align-items-start"
            :clearFilterStoreRef="clearAllFilters"
            
          >
            <div
              v-for="(item, index) in filters"
              :key="index"
              :class="filterClasses[item.title]"
              @click="handleFiltersClick(item, $event, index)"
            >
              <i :class="filterIconPre[item.type]"></i>
              {{
                item.group == "SORT"
                  ? appliedSortFilters.length > 0
                    ? appliedSortFilters[0].title
                    : item.title
                  : item.title
              }}
              <i :class="filterIconPost[item.viewType]"></i>
            </div>
          </div>

          <div class="fs-11 lh16" v-if="!isNonAnchorLinkVariant" >
            <horizontal-banner-with-anchor-links></horizontal-banner-with-anchor-links>
          </div>
        </div>
      </div>
    </div>
    <!-- filter select popup -->
    <generic-modal
      v-if="showMilestoneModal"
      @close="closeModal()"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
      :genericModalSource="'OrderFiltersPopup'"
    >
      <template v-slot:header>
        <p class="modal-title fs-18 lh25 bold mb20 ml10">Sort by</p>
        <i @click="closeModal(true)" class="jfi-cross sticky-pop-cross"></i>
      </template>
      <template v-slot:body>
        <ul class="list-wrap">
          <li
            class="list-item fs-14 lh20 pl10 pt10 pb10 flex-row"
            v-for="(item, index) in sortOptions"
            :key="index"
            @click="applyFilter($event, item)"
          >
            <span
              :class="{ dot: appliedSortFilters[0]?.title == item.title }"
              >{{ item.title }}</span
            >
            <span><i class="jfi-arrow-line ml7"></i></span>
          </li>
        </ul>
        <p
          class="clear-sort-cta fs-12 lh18 bold flex-row hand color-secondary"
          @click="clearSortFilter($event)"
          v-if="appliedSortFilters[0]"
        >
          Reset
        </p>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import "vue3-carousel/dist/carousel.css";
import { keyMapsMutation, keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import LocalStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import { defineAsyncComponent } from "vue";
import Observer from "../assets/Observer.vue";
import { VWO_NEXTGEN_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import {IS_BG} from "../config/apiEndpoints";

export default {
  name: "FilterMenuAnchorLinks",
  props: ["dataResults", "moduleProps"],

  components: {
    GenericModal,
    HorizontalBannerWithAnchorLinks: defineAsyncComponent(() =>
      import("./HorizontalBannerWithAnchorLinks.vue")
    ),
    Observer,
  },

  data() {
    return {
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout",
      },
      showMilestoneModal: false,
      filterIconPre: {
        VEG: "tag-veg mr5",
        NONVEG: "tag-non-veg mr5",
      },
      filterIconPost: {
        select: "jfi-arrow-line ml7",
        sort: "jfi-arrow-switch ml7",
      },
      filterClasses: {},
      filters: [],
      sortOptions: [],
      appliedFilters: [],
      appliedSortFilters: [],
      cachedComponentOffsetTop: 0,
      preWindowYOffset: 0,
      eleIdToObserve: "undefined-from-filters",
      resetFilter: true,
      modulePropsData: {},
      tagImgObjIs: {},
      isEdvPage: false,
    };
  },

  mounted() {
    this.isEdvPage = Utility.isEdvPage();
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    let foundSort = false;

    let flt = (this.dataResults && JSON.parse(this.dataResults)) || [];
    flt.forEach(obj => {
      if (obj.group && obj.group.startsWith('EDV_')) {
        obj.group = obj.group.slice(4);
      }
      if (obj.type && obj.type.startsWith('PRICE_')) {
        obj.type = obj.type.slice(6);
      }
    });

    this.sortOptions = flt.filter((_) => {
      return _.group == "SORT";
    });

    this.filters = flt
      .filter((_) => {
        if (_.group != "SORT") {
          return true;
        } else if (!foundSort) {
          foundSort = true;
          return true;
        } else {
          return false;
        }
      })
      .map((_) => {
        let __ = Object.assign({}, _);
        if (__.group == "SORT") {
          __.title = "Sort by";
        }
        return __;
      });

    //this.resetFilterRelatedUI();
    if(this.isEdvPage){
      this.loadOrderFiltersFromSession();
    }

    if (
      this.productObserver &&
      this.eleIdToObserve &&
      document.getElementById(this.eleIdToObserve)
    ) {
      this.productObserver.observe(
        document.getElementById(this.eleIdToObserve)
      );
    }

    const {tagImageObj = null} =  this.modulePropsData;
    this.tagImgObjIs =
      typeof tagImageObj != null &&
      typeof tagImageObj
        ? JSON.parse(tagImageObj)
        : {};
     
      if(this.tagImgObjIs && Object.keys(this.tagImgObjIs)?.length > 0){
        this.$store.commit(keyMapsMutation.UPDATE_TAG_IMAGE_INFO_OBJ , this.tagImgObjIs);
      }  
  },

  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.eleIdToObserve));
    }
  },

  methods: {
    handleFiltersClick(item, e, index) {
      userActivityTracking.filterApplied(item.title, index, 0);
      //Amplitude Click event load
      const preEventObj = {
        screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
        positionWithinSection: index + 1,
        category:
          item.title?.toLowerCase() == "sort by"
            ? "sortby popup"
            : item.title?.toLowerCase(),
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "filters",
        "6",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);

      if (item.group == "SORT" || item.options?.length > 0) {
        this.triggerModal(e);
      } else {
        this.applyFilter(e, item);
      }
    },
    clearSortFilter(e) {
      this.appliedSortFilters = [];
      this.filterIconPost.sort = "jfi-arrow-switch ml7";
      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [...this.appliedFilters, ...this.appliedSortFilters],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters["Cart/cartQuantity"],
      });
      this.filterClasses["Sort by"] =
        "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
      this.closeModal();
      this.goto();
      //Amplitude Click event load
      const preEventObj = {
        screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
        positionWithinSection: "3",
        category: "sortby popup",
        subCategory: "reset",
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "filters",
        "6",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
      this.updateAppliedFiltersInLocalStorage();
    },
    applyFilter(e, item) {
      if (item.group == "SORT") {
        this.appliedSortFilters = [item];
        if (item.type == "HIGH_TO_LOW") {
          this.filterIconPost.sort = "jfi-long-arrow arrow-down ml7";
        } else if (item.type == "LOW_TO_HIGH") {
          this.filterIconPost.sort = "jfi-long-arrow arrow-up ml7";
        }
        this.filterClasses["Sort by"] =
          "order-filter-item flex-row fs-12 lh-18  ml3 mr3 selected-filter-item";
        //Amplitude Click event load
        const preEventObj = {
          screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
          positionWithinSection: item.position,
          category: "sortby popup",
          subCategory: item.title?.toLowerCase(),
        };
        const eventObj = Utility.amplitudeEventObj(
          "click",
          "filters",
          "6",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      } else {
        let addToAppliedFilter = true;
        for (var i = 0; i < this.appliedFilters.length; i++) {
          if (
            this.appliedFilters[i].group == item.group &&
            this.appliedFilters[i].type == item.type
          ) {
            addToAppliedFilter = false;
            this.filterClasses[item.title] =
              "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
            this.appliedFilters.splice(i, 1);
            break;
          }
        }
        if (addToAppliedFilter) {
          if (this.appliedFilters.length > 0) {
            this.filterClasses[this.appliedFilters[0].title] =
              "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
          }
          this.appliedFilters = [item];
          this.filterClasses[item.title] =
            "order-filter-item flex-row fs-12 lh-18  ml3 mr3 selected-filter-item";
        }
      }

      this.updateAppliedFiltersInLocalStorage();

      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [...this.appliedFilters, ...this.appliedSortFilters],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters["Cart/cartQuantity"],
      });
      this.closeModal();
      this.goto(item);
    },
    updateAppliedFiltersInLocalStorage() {
      this.$store.commit(keyMapsMutation.SET_ORDER_FILTER_DATA, {
        appliedFilters: this.appliedFilters,
        appliedSortFilters: this.appliedSortFilters,
      });
      LocalStorageFunc.setSessionStorageKey("orderFiltersData", {
        appliedFilters: this.appliedFilters,
        appliedSortFilters: this.appliedSortFilters,
      });
    },
    triggerModal(e) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.showMilestoneModal = true;
      //Amplitude Impression event load
      const eventObj = Utility.amplitudeEventObj("impression", "filters", "6", {
        screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
        category: "sortby popup",
      });
      setEvents("amplitude", "Impression", eventObj);
    },
    closeModal(isCrossClicked = false) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showMilestoneModal = false;
      if (isCrossClicked) {
        //Amplitude Click event load
        const preEventObj = {
          screenName: this.isEdvPage ? PageNames.NEXTGEN_EDVPAGE : '',
          positionWithinSection: "top right",
          category: "sortby popup",
          subCategory: "cross tap",
        };
        const eventObj = Utility.amplitudeEventObj(
          "click",
          "filters",
          "6",
          preEventObj
        );
        setEvents("amplitude", "Click", eventObj);
      }
    },
    resetFilterRelatedUI() {
      this.appliedFilters = [];
      this.appliedSortFilters = [];
      this.filters.map((_) => {
        this.filterClasses[_.title] =
          "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
      });
    },
    loadOrderFiltersFromSession() {
      this.filters.map((_) => {
        this.filterClasses[_.title] =
          "order-filter-item flex-row fs-12 lh-18  ml3 mr3";
      });

      let _ = LocalStorageFunc.getSessionStorageKey("orderFiltersData");
      _.appliedFilters?.forEach((item) => {
        this.applyFilter("", item);
      });
      _.appliedSortFilters?.forEach((item) => {
        this.applyFilter("", item);
      });
    },
    updateProductCounterString(productCounter) {
      this.$store.commit(
        keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
        productCounter
      );
    },
    goto(item) {
      /* if (this.getRecommendedProducts?.length > 0) {
          Utility.scrollUptoTo("recommendedItems");
          return;
        } */
      const firstItem = Object.values(this.getBottomBarData)?.[0] || {};
      let itmId = firstItem?.categoryId;
      let categoryName = firstItem?.categoryName;
      let count = firstItem?.data ? Object.keys(firstItem.data).length : 0;
      if(Utility.isEdvPage()){
        const EdvCategoryClickedInfo = this.$store.state.Edv.edvCategoryClickedInfo;
        const ClickeditemId = EdvCategoryClickedInfo?.itmId;
        const productItems = this.$store.state.ProductItems.productItems || {};
        const hasDataInCategory = Object.values(productItems).some(
          ({ categoryId, data }) => Number(categoryId) === Number(ClickeditemId) && data && Object.keys(data).length > 0
        );
        if(hasDataInCategory){
          itmId = ClickeditemId;
          categoryName = EdvCategoryClickedInfo.categoryName;
          count = EdvCategoryClickedInfo.count;
        }
        if(itmId){
          setTimeout(() => {
            this.$store.commit(
              keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
              categoryName + " (" + count + ")"
            );
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
              true
            );
            this.$store.commit(
              keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
              categoryName
            );
          }, 0);
        }
      }
      // @todo - this needs to be refactored
      if(IS_BG){
        this.updateProductCounterString(categoryName);
      }
      else if(Utility.isSeparateMenuVariant()) {
        if (this.appliedFilters.length > 0) {
          if(item) {
            if (item.type === "VEG") {
              itmId = "2";
              this.updateProductCounterString("Veg Pizza");
            }
            else if(item.type === "NONVEG") {
              itmId = "3";
              this.updateProductCounterString("Non-Veg Pizza");
            }
            else if(item.group === "SORT") {
              let appliedFilter = this.appliedFilters[0];
              if (appliedFilter.type === "VEG") {
                itmId = "2";
                this.updateProductCounterString("Veg Pizza");
              }
              else if(appliedFilter.type === "NONVEG") {
                itmId = "3";
                this.updateProductCounterString("Non-Veg Pizza");
              }
            }
          }
          else {
            let appliedFilter = this.appliedFilters[0];
            if (appliedFilter.type === "VEG") {
              itmId = "2";
              this.updateProductCounterString("Veg Pizza");
            }
            else if(appliedFilter.type === "NONVEG") {
              itmId = "3";
              this.updateProductCounterString("Non-Veg Pizza");
            }
          }
        }
      }

      if (itmId) {
        this.$store.commit(
          keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK,
          true
        );
        Utility.scrollUptoTo("element_catg_" + itmId);
      } else {
        Utility.scrollUptoTo("pageTop");
      }
    },
  },
  computed: {
    getRecommendedProducts() {
      return this.$store.getters[keyMapsGetter.GET_RECOMMENDED_PRODUCTS]();
    },
    getBottomBarData() {
      return this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEM_FOR_BOTTOMBAR];
    },
    clearAllFilters() {
      return;
      let _ = this.$store.state.ProductItems.clearFilterRef;
      if (_) {
        this.resetFilterRelatedUI();
        this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, []);
      }
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.eleIdToObserve &&
        document.getElementById(this.eleIdToObserve)
      ) {
        observer.observe(document.getElementById(this.eleIdToObserve));
      }
      return observer;
    },
    shouldVisible() {
      return (
        this.isTrueLocationDetected ||
        this.isLocationPermisssionGiven
      );
    },
    getObserverOptions() {
      if (Utility.isSeparateMenuVariant()) {
        this.resetFiltersAndInsertCounterString;
        return { root: null,threshold: 0,rootMargin: '0%' };
      }
      else {
        return {rootMargin: '-50px'};
      }
    },
    resetFiltersAndInsertCounterString() {
      let productItems = this.getBottomBarData;
      if(this.resetFilter && Object.keys(productItems).length > 0) {
          this.resetFilter = false;
          let queryParams = Utility.getQueryFromUrl();
          let scrollToParam = queryParams["scrollTo"] 
                              || queryParams["cat_id"]
                              || queryParams["categoryId"]
                              || "";
          let onScroll;
          if(scrollToParam !== undefined && scrollToParam !== "" ) {
            onScroll = Number(scrollToParam);
          }
          else {
            onScroll = productItems[Object.keys(productItems)[0]]?.categoryId;
          }
          let keyFound = false;
          for (const product in productItems) {
            if(Number(productItems?.[product]?.categoryId) === onScroll) {
              keyFound = true;
              this.$store.commit(
                keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
                productItems?.[product]?.categoryName
              );
              break;
            }
          }
          if(!keyFound) {
            this.$store.commit(
                keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
                productItems[Object.keys(productItems)[0]]?.categoryName
              );
          }

          this.resetAllFilters;
        }
    },
    resetAllFilters() {
      this.appliedSortFilters = [];
      this.filterIconPost.sort = "jfi-arrow-switch ml7";
      LocalStorageFunc.setSessionStorageKey("orderFiltersData", {});
      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters["Cart/cartQuantity"],
      });
      this.loadOrderFiltersFromSession();
    },
    isNonAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === "nextgen_variant_x"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLocationPermisssionGiven() {
      return this.$store.state.Location.isLocationPermissionGiven;
    },
    getBackgroundImage() {
      const { backgroundImage = '' } = this.modulePropsData;
      let backgroundImageCss = '';
      if(backgroundImage !== '') {
        backgroundImageCss = `
          background-image: url('${backgroundImage}');
          background-repeat: no-repeat;
          background-size: cover;
        `;
      }
      return backgroundImageCss;
    }
  },
  watch: {
    getBottomBarData: {
      handler(newVal, oldVal) {
        if(newVal.length > 0 && this.resetFilter) {
          this.resetFiltersAndInsertCounterString;
        }
      },
    },
  },
};
</script>

<style scoped></style>
